<template>
  <el-dialog
    :visible.sync="valuesToRefinanceModalShow"
    width="40%"
    @closed="$emit('close')"
  >
    <div class="row" slot="title">
      <div class="col-12">
        <h4 class="m-0">Values to Refinance</h4>
        <small class="text-light-gold">{{ closeout_business.name }}</small>
      </div>
    </div>
    <div class="row" v-loading="loading">
      <div class="col-12 mb-2 text-warning break-word" v-if="total_of_pic > 0">
        There are animals off PIC for one or more of the selected trades. Off
        PIC animals cannot be refinanced. As such, the following values do not
        include off PIC animals.
      </div>
      <div class="col-12 font-weight-bold label-field" v-if="false">
        Settlement Date <span class="required-flag">*</span>
      </div>
      <div
        class="col-12 mb-2"
        v-if="
          can(this.$userAccess.permissions.client_portal_view_management_fee)
        "
      >
        <el-date-picker
          v-model="closeoutForm.settlement_date"
          value-format="yyyy-MM-dd"
          format="dd/MM/yyyy"
          type="date"
          class="w-50"
          placeholder="Pick a settlement date"
          :picker-options="pickerOptions"
          @change="getRefinanceValues"
          :disabled="loading"
        ></el-date-picker>
      </div>
      <div
        class="col-12"
        v-if="
          can(this.$userAccess.permissions.client_portal_view_management_fee)
        "
      >
        <div class="row pt-2 pb-1 mb-1 border-bottom font-weight-bold">
          <div class="col-2 break-word">Trade #</div>
          <div class="col-2 text-center break-word">No Head</div>
          <div class="col-8 row">
            <div class="col-4 text-center break-word">
              Livestock Balance (ex)
            </div>
            <div class="col-4 text-center break-word">Management Fee (ex)</div>
            <div class="col-4 text-center break-word">Deposit Bal</div>
          </div>
        </div>
        <div
          class="row py-1"
          v-for="(purchaseVal, index) in purchaseValues"
          :key="index"
        >
          <div class="col-2 break-word">{{ purchaseVal.ref_id }}</div>
          <div class="col-2 text-center">{{ purchaseVal.on_pic }}</div>
          <div v-if="closeoutForm.error" class="text-danger col-8 text-center">
            {{ closeoutForm.message }}
          </div>
          <div v-else class="col-8 row">
            <div class="col-4 text-center break-word" v-loading="loading">
              <span>
                {{
                  purchaseVal.livestock_balance_ex_gst
                    ? "$" +
                      $_toLocaleString(purchaseVal.livestock_balance_ex_gst, 2)
                    : ""
                }}
              </span>
            </div>
            <div class="col-4 text-center break-word" v-loading="loading">
              <span>
                {{
                  "$" +
                  $_toLocaleString(purchaseVal.management_fee_balance_ex_gst, 2)
                }}
              </span>
            </div>
            <div class="col-4 text-center break-word" v-loading="loading">
              <span>
                {{ "$" + $_toLocaleString(purchaseVal.livestock_deposit, 2) }}
              </span>
            </div>
          </div>
        </div>
        <div class="row mt-3 mr-4">
          <div class="col-9 text-right">Sub total</div>
          <div class="col-3 text-right">
            {{ "$" + $_toLocaleString(values.sub_total, 2) }}
          </div>
        </div>

        <div class="row mr-4">
          <div class="col-9 text-right">GST</div>
          <div class="col-3 text-right">
            {{ "$" + $_toLocaleString(values.gst, 2) }}
          </div>
        </div>
        <div class="row mr-4">
          <div class="col-9 text-right">Total</div>
          <div class="col-3 text-right">
            {{ "$" + $_toLocaleString(values.total, 2) }}
          </div>
        </div>
      </div>
      <div v-else class="col-12">
        <div class="row pt-2 pb-1 mb-1 border-bottom font-weight-bold">
          <div class="col-4 break-word">Trade #</div>
          <div class="col-2 text-center break-word">No Head</div>
          <div class="col-6 text-center break-word">Livestock Balance (ex)</div>
        </div>
        <div
          class="row"
          v-for="(purchaseVal, index) in purchaseValues"
          :key="index"
        >
          <div class="col-4 break-word">{{ purchaseVal.ref_id }}</div>
          <div class="col-2 text-center">{{ purchaseVal.on_pic }}</div>
          <div class="col-6 text-center break-word" v-loading="loading">
            <span v-if="!closeoutForm.error">
              {{
                purchaseVal.livestock_balance_ex_gst
                  ? "$" +
                    $_toLocaleString(purchaseVal.livestock_balance_ex_gst, 2)
                  : ""
              }}
            </span>
            <small
              v-else
              :class="closeoutForm.error ? 'text-danger' : 'text-grey'"
              >{{ closeoutForm.message }}</small
            >
          </div>
        </div>
      </div>
    </div>
    <div class="text-right w-100 mt-3">
      <el-button class="btn-secondary" @click="$emit('close')">Close</el-button>
    </div>
  </el-dialog>
</template>

<script>
import OttleyFormatter from "../mixins/OttleyFormatter";
export default {
  mixins: [OttleyFormatter],
  props: {
    closeout_purchases: {
      type: Array,
    },
    closeout_business: {
      type: Object,
    },
    closeout_livestock_class_id: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      valuesToRefinanceModalShow: true,
      closeoutForm: {
        settlement_date: null,
        error: false,
        message: "--",
      },
      purchaseValues: [],
      values: {
        sub_total: 0,
        gst: 0,
        total: 0,
      },
    };
  },
  computed: {
    pickerOptions() {
      let self = this;
      return {
        disabledDate(time) {
          let invoiceDueDates = self.closeout_purchases.map(
            ({ invoice_due_date }) => invoice_due_date,
          );
          let min = invoiceDueDates.reduce(function (a, b) {
            return a < b ? a : b;
          });

          return (
            time.getTime() <= Date.now() ||
            [0, 6].includes(time.getDay()) ||
            time.getTime() > moment(min)
          );
        },
      };
    },
    total_of_pic() {
      return this.closeout_purchases.reduce(
        (prev, curr) => prev + Number(curr.off_pic),
        0,
      );
    },
  },
  mounted() {
    this.calculateDate();
    this.getRefinanceValues();
  },
  methods: {
    calculateDate() {
      let invoiceDueDates = this.closeout_purchases.map(
        ({ invoice_due_date }) => invoice_due_date,
      );
      let minSettlementDate = invoiceDueDates.reduce(function (a, b) {
        return a < b ? a : b;
      });
      this.closeoutForm.settlement_date = minSettlementDate;
    },
    getRefinanceValues() {
      this.loading = true;
      self = this;
      self.closeoutForm.error = false;
      self.closeoutForm.message = "";
      if (self.closeoutForm.settlement_date) {
        let data = {
          settlement_date: self.closeoutForm.settlement_date,
          purchase_ids: self.closeout_purchases.map(({ id }) => id),
        };
        axios
          .post(`/api/v2/closeout-purchases/refinance-values`, data)
          .then((res) => {
            let data = res.data;
            self.purchaseValues = self.closeout_purchases;
            self.purchaseValues.forEach((purchase) => {
              let count = data.filter(
                (d) => d.purchase_id == purchase.id,
              ).length;

              if (count == 1) {
                let purchaseData = data.find(
                  (d) => d.purchase_id == purchase.id,
                );
                purchase.livestock_balance_ex_gst = Number(
                  (purchaseData.livestock_balance_ex_gst / purchase.open_head) *
                    purchase.on_pic,
                );
                purchase.management_fee_balance_ex_gst =
                  purchaseData.management_fee_balance_ex_gst;
                purchase.livestock_deposit =
                  purchaseData.purchase_livestock_deposit;
              } else {
                self.closeoutForm.error = true;
                self.closeoutForm.message =
                  "We could not calculate the values to refinance, please contact Ottley";
              }
            });

            if (self.closeoutForm.error) {
              self.values = {
                sub_total: 0,
                gst: 0,
                total: 0,
              };
            } else {
              this.values.sub_total = this.purchaseValues.reduce(function (
                prev,
                curr,
              ) {
                return (
                  prev +
                  Number(curr.livestock_balance_ex_gst) +
                  Number(curr.management_fee_balance_ex_gst) -
                  Number(curr.livestock_deposit)
                );
              }, 0);
              this.values.gst =
                (this.purchaseValues.reduce(function (prev, curr) {
                  return (
                    prev +
                    Number(curr.livestock_balance_ex_gst) +
                    Number(curr.management_fee_balance_ex_gst)
                  );
                }, 0) *
                  10) /
                100;
              this.values.total = this.values.sub_total + this.values.gst;
            }
          })
          .catch((errors) => {
            console.log(errors);
          })
          .finally((_) => {
            self.loading = false;
          });
      } else {
        self.purchaseValues = [];
        self.values = {
          sub_total: 0,
          gst: 0,
          total: 0,
        };
      }
    },
  },
};
</script>

<style scoped>
.break-word {
  word-break: break-word;
}
</style>
